import PinFilledIcon from '@atlaskit/icon/core/pin-filled';
import * as React from 'react';

export function SvgPinFill() {
  return <PinFilledIcon label="" testId="ads-refreshed-icon" />;
}
